import { useParams } from 'react-router'
import { ComponentWithPermissions } from '../../../../baseComponents/CreateRoutering/types'
import TwinTable from '../../../../baseComponents/TwinTable'
import BaseScreenTableInner from '../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { TableComponentBaseScreenInnerProps } from '../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { CustomRenderString, CustomRenderStringAndColorNull, CustomRenderDateHours, EditRow } from '../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import ModalEditCampaignCustomer from '../../../ModalEditCampaignCustomer'
import { CampaignCustomerModelTypeExtForCustomerProfile } from '../../types'
import ModalCreateCustomerCampaign from './ModalCreateCustomerCampaign'
import { EmployeesPayload } from '../../../../utils/reducers/company/employees'
import { connect, ConnectedProps } from 'react-redux'
import { AllReduxPayloads } from '../../../../utils/reducers'
import withLoading from '../../../../utils/hoc/withLoading'
import { useMemo } from 'react'
import { getAllClientManagerEmployees, getConfigParam } from '../../../../utils/reducers/getters'


interface CustomerCampaignsProps extends ComponentWithPermissions {
}

const CustomerCampaigns: React.FC<CustomerCampaignsProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const params = useParams<{ id: string }>()
    const id = params.id
    const pageData = {
        title: t('campaigns', 'Campañas'),
        newText: t('addCampaign', 'Añadir campaña'),
    }

    return (
        <BaseScreenTableInner TableComponent={TableCustomerCampaignsConnect} extraWhereParams={{ 'CustomerId': id }} pageData={pageData} CreateModalComponent={ModalCreateCustomerCampaign} EditModalComponent={ModalEditCampaignCustomer} userPermissions={userPermissions} />
    )
}

type TableCustomerCampaignsProps = & TableComponentBaseScreenInnerProps & ReduxCustomerAndCampaigns & {
    className?: string
    name?: string
    hideLoadFiltersButton?: boolean
}

const TableCustomerCampaigns: React.FC<TableCustomerCampaignsProps> = ({ setTableInstance, extraWhereParams, setOpened, employees, ...rest }) => {
    const { t } = useTwinTranslation()
    const myEmployees = useMemo(() => getConfigParam('showOnlyClientManagerEmployees') === 'on' ? getAllClientManagerEmployees() || {} : employees || {}, [employees])
    const columns: ColumnTableSchema<CampaignCustomerModelTypeExtForCustomerProfile> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
            width: 75
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('campaign', 'Campaña'),
            customRender: (_parameterValue, allRowData) => <CustomRenderString value={allRowData?.Campaign?.name} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            },
            searchKey: 'Campaign.name'
        },
        {
            id: 'CurrentCampaignStatusId',
            dataKey: 'CurrentCampaignStatusId',
            label: t('status', 'Estado'),
            minWidth: 120,
            customRender: (_parameterValue, allRowData) => <CustomRenderStringAndColorNull value={allRowData?.CurrentCampaignStatus?.name} color={allRowData?.CurrentCampaignStatus?.color} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('status', 'Estado') }
            },
            searchKey: 'CurrentCampaignStatus.name',
            sortable: true,
            sortKey: 'CurrentCampaignStatus.order'
        },
        {
            id: 'ResponsibleEmployeeId',
            dataKey: 'Customer',
            label: t('ourManager', 'Nuestro gestor'),
            minWidth: 170,
            customRender: (_parameterValue, allRowData) => <CustomRenderString value={allRowData?.Customer?.ResponsibleEmployee?.fullname_short} />,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSearchBar',
                extraComponentData: { items: myEmployees, label: t('ourManager', 'Nuestro gestor'), fieldName: 'fullname_short' }
            },
            searchSingleKey: 'Customer.ResponsibleEmployee.id',
            searchKey: 'Customer.ResponsibleEmployee.fullname_short'
        },
        {
            id: 'date',
            dataKey: 'date',
            label: t('limitDate', 'Fecha límite'),
                customRender: (parameterValue) => <CustomRenderDateHours value={parameterValue} />
        },
        {
            id: 'dateLastAction',
            dataKey: 'dateLastAction',
            label: t('dateLastAction', 'Fecha última acción'),
            minWidth: 175,
            customRender: (parameterValue) => <CustomRenderDateHours value={parameterValue} />,
            sortable: true,
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} />
        },
    ]
    return (
        <TwinTable name='CustomerCampaignCustomers' columns={columns} getDataFrom='/api/app/customer/campaign/customer/getAllCampaignCustomers'
            onRowClick={(_id, rowData) =>setOpened({
                type: 'edit',
                allRowData: { id: rowData?.id }
            })}
            setTableInstance={setTableInstance} extraWhereParams={extraWhereParams} {...rest} />
    )
}

const customersAndCampaignsDispatch = {
    setEmployees: (payload: EmployeesPayload) => ({ type: 'CHANGE_EMPLOYEE', payload }),
}

export type ReduxCustomerAndCampaigns = ConnectedProps<typeof customersAndCampaignsConnect>
const mapCustomersAndCampaignsConnector = (state: AllReduxPayloads) => ({ employees: state.employees })
const customersAndCampaignsConnect = connect(mapCustomersAndCampaignsConnector, customersAndCampaignsDispatch)
const customersAndCampaignsConnectLoading = withLoading(TableCustomerCampaigns, [{ fetchUrl: '/api/app/employee/getAllEmployees', propName: 'employees', setFunctionName: 'setEmployees' }])
export const TableCustomerCampaignsConnect = customersAndCampaignsConnect(customersAndCampaignsConnectLoading)

export default CustomerCampaigns